import Loadable from '../../components/loadable';

const PendingWaiversList = Loadable({
  loader: () => import('../../pages/waivers/pending_waivers_list/pending_waivers_list'),
  type: 'block',
});

angular.module('gym').value('PendingWaiversList', PendingWaiversList);

const PendingWaiversListFiltersModal = Loadable({
  loader: () =>
    import('../../pages/waivers/pending_waivers_list/pending_waivers_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PendingWaiversListFiltersModal', PendingWaiversListFiltersModal);
